"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

var _Asterisk = _interopRequireDefault(require("@decisiv/iconix/lib/components/Asterisk"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var RequiredIconContainer = _styledComponents.default.div.withConfig({
  displayName: "RequiredIcon__RequiredIconContainer",
  componentId: "sc-18pnvm5-0"
})(["display:inline;margin-left:", ";margin-top:", ";"], function (props) {
  return props.marginLeft || '3px';
}, function (props) {
  return props.marginTop || '0px';
});

var RequiredIcon = (0, _react.forwardRef)(function (props, ref) {
  return _react.default.createElement(RequiredIconContainer, _extends({}, props, {
    ref: ref
  }), _react.default.createElement(_Asterisk.default, {
    color: (0, _toColorString.default)(_color.default.status.information.medium),
    size: "small"
  }));
});
var _default = RequiredIcon;
exports.default = _default;